import { v } from "convex/values";

/**
 * Langues de l'interface. Le champ `users.language` en garde une ; absent,
 * l'app suit la langue du navigateur.
 *
 * Ajouter une langue : l'ajouter ici, puis créer src/locales/<code>/ avec les
 * mêmes fichiers que src/locales/en/ (un test vérifie qu'aucune clé ne manque).
 */
export const SUPPORTED_LANGUAGES = ["en", "fr"] as const;

export type Language = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: Language = "en";

export const languageValidator = v.union(v.literal("en"), v.literal("fr"));

export function isLanguage(value: unknown): value is Language {
  return (SUPPORTED_LANGUAGES as readonly unknown[]).includes(value);
}
